import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

import { AuthGuard } from '~/auth/guards/auth.guard';
import { OrganizerSharedGetOrganizationByQueryIdGuard } from '~/organizer/shared/guards/get-organization-by-query-id/get-organization-by-query-id.guard';
import { OrganizerSharedGetOrganizationFromAuthUserGuard } from '~/organizer/shared/guards/get-organization-from-auth-user/get-organization-from-auth-user.guard';
import { OrganizerSharedHasOrganizationGuard } from '~/organizer/shared/guards/has-organization/has-organization.guard';
import { OrganizerSharedTimeslotParticipantListResolver } from '~/organizer/shared/resolvers/timeslot/participant/list/list.resolver';
import { OrganizerSharedTimeslotResolver } from '~/organizer/shared/resolvers/timeslot/timeslot.resolver';

import { OrganizerMessagingPageContactComponent } from './components/pages/contact/contact.component';
import { OrganizerMessagePageInboxComponent } from './components/pages/inbox/inbox.component';

const routes: Routes = [
  {
    path: 'organizer.messaging.inbox',
    component: OrganizerMessagePageInboxComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.messaging.contact/:id',
    component: OrganizerMessagingPageContactComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
    resolve: {
      timeslotData: OrganizerSharedTimeslotResolver,
      bookingItemsGroupByUserId: OrganizerSharedTimeslotParticipantListResolver,
    },
  },
];

/**
 * Prefix route of the sub modules
 */
@NgModule({
  imports: [
    RouterModule.forChild(routes),
    LocalizeRouterModule.forChild(routes),
  ],
  exports: [RouterModule, LocalizeRouterModule],
})
export class OrganizerMessagingRoutingModule {}
